import React from "react";
import { useMsal } from "@azure/msal-react";
import {
    Button,
} from "@chakra-ui/react"

function handleLogout(instance: any) {
    instance.logoutPopup().catch((e: any) => {
        console.error(e);
    });
}

/**
 * Renders a button which, when selected, will open a popup for logout
 */
export const SignOutButton = () => {
    const { instance } = useMsal();

    return (
        <Button colorScheme="blue" variant="link" onClick={() => handleLogout(instance)}>Sign out</Button>
    );
}